export default __webpack_public_path__ + "static/media/txt.a20f2076.svg";